import React from "react";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { IOrganisationDetailsPresenter } from "../../presenter/OrganisationDetailsPresenter";
import { Button, Divider, Layout } from "antd";
import Text from "antd/lib/typography/Text";
import { FileAddOutlined } from "@ant-design/icons";
import InstitutionDetailsSidebar from "../components/InstitutionDetailsSidebar";
const { Sider } = Layout;
export interface Props extends PageProps {}

export interface State extends IOrganisationDetailsPresenter {}

export default class OrganisationDetailsPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      showCategories,
      translate,
      showAttachmentTypes,
      showCaseLawDocumentTypes,
      organisation,
      institutionDetails,
      showCaseDecisionTypes,
      showLegalViewTypes
    } = this.state;

    return (
      <Page {...this.props}>
        <Layout>
          <Sider
            className={"content-container dashboard-sider  "}
            breakpoint="xl"
            collapsedWidth="0"
            collapsible
            width={"22%"}
            style={{ height: "100vh" }}
          >
            <div className={"dashboard-sider-project-title-wrapper"}>
              <Text className={"dashboard-sider-project-title"}>
                {organisation?.name}
              </Text>
            </div>
            <InstitutionDetailsSidebar
              translate={translate}
              institutionDetails={institutionDetails}
            />
            <Divider />
            <div>
              <Button
                icon={<FileAddOutlined />}
                onClick={() => showCategories()}
                size="middle"
                type="link"
              >
                {translate(
                  "editors.organisations.details.index_type_categories"
                )}
              </Button>
            </div>
            <Divider />
            <div>
              <Button
                icon={<FileAddOutlined />}
                onClick={() => showAttachmentTypes()}
                size="middle"
                type="link"
              >
                {translate("editors.organisations.details.attachment_types")}
              </Button>
            </div>
            <Divider />
            <div>
              <Button
                icon={<FileAddOutlined />}
                onClick={() => showCaseLawDocumentTypes()}
                size="middle"
                type="link"
              >
                {translate(
                  "editors.organisations.details.case_law_document_types"
                )}
              </Button>
            </div>{" "}
            <Divider />
            <div>
              <Button
                icon={<FileAddOutlined />}
                onClick={() => showCaseDecisionTypes()}
                size="middle"
                type="link"
              >
                {translate(
                  "editors.organisations.details.case_decisions_types"
                )}
              </Button>
            </div>{" "}
            <Divider />
            <div>
              <Button
                icon={<FileAddOutlined />}
                onClick={() => showLegalViewTypes()}
                size="middle"
                type="link"
              >
                {translate("editors.organisations.details.legal_view_types")}
              </Button>
            </div>
          </Sider>
        </Layout>
      </Page>
    );
  }
}
